import React from "react";
import SampleVoterIdPopup from "./SampleVoterIdPopup";

export interface ISampleVoterIDMobileViewProps {
  setShowPopup: Function;
  showPopup: boolean;
  text?: any;
  children?: any;
}

// Mobile uses the same centred modal (single column, internal scroll) as
// desktop instead of a bottom sheet.
const SampleVoterIDMobileViewProps = (props: ISampleVoterIDMobileViewProps) => (
  <SampleVoterIdPopup showPopup={props.showPopup} setShowPopup={props.setShowPopup} />
);
export default SampleVoterIDMobileViewProps;
